import { buildLink,Link  } from '@caritas/ui';

export type Pager = {
  name: string;
  totalItems?: number;
  itemsPerPage?: number;
  pagesToShow?: number;
  setCurrentPage: any;
  currentPage: string;
  onPageChange?: () => void;
};

export type PagerPage = {
  number: number;
  Link?: Link;
};

export const usePager = (pagerDetails: Pager) => {
  const totalPages =
    pagerDetails.totalItems &&
    pagerDetails.itemsPerPage &&
    pagerDetails.itemsPerPage > 0
      ? Math.ceil(pagerDetails.totalItems / pagerDetails.itemsPerPage)
      : 1;
  const currentPageInt = parseInt(pagerDetails.currentPage);
  const pagesToShow = pagerDetails.pagesToShow || 5;
  let currentDistance = 1;
  let hasMissingLeftPages = true;
  let hasMissingRightPages = true;

  const firstPage =
    currentPageInt > 0
      ? buildLink({
          href: '#',
          onClick: (e) => {
            pagerDetails.setCurrentPage('0');
            if (pagerDetails.onPageChange) {
              pagerDetails.onPageChange();
            }
            e.preventDefault();
            e.stopPropagation();
          },
        })
      : undefined;
  const previousPage =
    currentPageInt > 0
      ? buildLink({
          href: '#',
          onClick: (e) => {
            pagerDetails.setCurrentPage((currentPageInt - 1).toString());
            if (pagerDetails.onPageChange) {
              pagerDetails.onPageChange();
            }
            e.preventDefault();
            e.stopPropagation();
          },
        })
      : undefined;
  const nextPage =
    currentPageInt < totalPages - 1
      ? buildLink({
          href: '#',
          onClick: (e) => {
            pagerDetails.setCurrentPage((currentPageInt + 1).toString());
            if (pagerDetails.onPageChange) {
              pagerDetails.onPageChange();
            }
            e.preventDefault();
            e.stopPropagation();
          },
        })
      : undefined;
  const lastPage =
    currentPageInt < totalPages - 1
      ? buildLink({
          href: '#',
          onClick: (e) => {
            pagerDetails.setCurrentPage((totalPages - 1).toString());
            if (pagerDetails.onPageChange) {
              pagerDetails.onPageChange();
            }
            e.preventDefault();
            e.stopPropagation();
          },
        })
      : undefined;
  const pages: PagerPage[] = [
    {
      number: currentPageInt + 1,
    },
  ];
  // To generate the pages, we just add one page to the left and one to the
  // right until we either can't add any page or we added the maximum number of
  // pages.
  while (pages.length < pagesToShow && currentDistance < totalPages) {
    const leftPage = currentPageInt - currentDistance;
    const rigthPage = currentPageInt + currentDistance;
    // Check if the left page is actually a valid one (between 0 and the maximum
    // number of pages)
    if (leftPage >= 0 && leftPage < totalPages) {
      pages.unshift({
        number: leftPage + 1,
        Link: buildLink({
          href: '#',
          title: leftPage.toString(),
          onClick: (e) => {
            pagerDetails.setCurrentPage(leftPage.toString());
            if (pagerDetails.onPageChange) {
              pagerDetails.onPageChange();
            }
            e.preventDefault();
            e.stopPropagation();
          },
        }),
      });
    }
    // The same validation like above is done for the right page, to make sure
    // it is in right interval. Additionally, we check if we filled in the
    // pages array.
    if (
      pages.length < pagesToShow &&
      rigthPage < totalPages &&
      rigthPage >= 0
    ) {
      pages.push({
        number: rigthPage + 1,
        Link: buildLink({
          href: '#',
          title: rigthPage.toString(),
          onClick: (e) => {
            pagerDetails.setCurrentPage(rigthPage.toString());
            if (pagerDetails.onPageChange) {
              pagerDetails.onPageChange();
            }
            e.preventDefault();
            e.stopPropagation();
          },
        }),
      });
    }

    if (leftPage <= 0) {
      hasMissingLeftPages = false;
    }
    if (rigthPage >= totalPages - 1) {
      hasMissingRightPages = false;
    }

    currentDistance++;
  }

  return {
    firstPage,
    previousPage,
    nextPage,
    lastPage,
    pages,
    hasMissingLeftPages,
    hasMissingRightPages,
  };
};
